/** Same public asset as Event Configurator Step1 / Step4 (`public/`). */
export const AGV_CONFIGURATOR_IMAGE = "ek robotics-vario move l-freisteller-3840x2160-rgb.png";

/** Pixel width of AGV overlay for **base** chips (admin + Step1) — must match so stored % line up with the asset. */
export const AGV_OVERLAY_MAX_WIDTH_PX = 800;

/** Match source image aspect (3840×2160); used only for base-function chip overlay. */
export const AGV_OVERLAY_ASPECT_RATIO = "3840 / 2160" as const;

export function fallbackChipPercent(index: number, total: number): { chip_top: number; chip_left: number } {
  const safeTotal = Math.max(total, 1);
  const chip_left = safeTotal <= 1 ? 50 : ((index + 0.5) / safeTotal) * 100;
  return { chip_top: 88, chip_left };
}

export function resolveChipPercent(
  chip_top: number | null | undefined,
  chip_left: number | null | undefined,
  index: number,
  total: number
): { top: string; left: string } {
  if (chip_top != null && chip_left != null && Number.isFinite(chip_top) && Number.isFinite(chip_left)) {
    return { top: `${chip_top}%`, left: `${chip_left}%` };
  }
  const fb = fallbackChipPercent(index, total);
  return { top: `${fb.chip_top}%`, left: `${fb.chip_left}%` };
}
